const getAssignedIds = (value) =>
  Array.isArray(value) ? value.filter(Boolean) : [];

export const isEmptyLineupSnapshot = (snapshot) => {
  if (!snapshot) return false;

  const champion = snapshot.champion || snapshot.championId || null;
  const inRing = getAssignedIds(snapshot.inRing || snapshot.inRingIds);
  const backstage = getAssignedIds(snapshot.backstage || snapshot.backstageIds);

  return !champion && inRing.length === 0 && backstage.length === 0;
};

export const buildFactionLineupHistoryRepair = (faction) => {
  const lineupHistory = Array.isArray(faction?.lineupHistory)
    ? faction.lineupHistory
    : [];
  const cleanedLineupHistory = lineupHistory.filter(
    (snapshot) => !isEmptyLineupSnapshot(snapshot)
  );
  const removedCount = lineupHistory.length - cleanedLineupHistory.length;

  return {
    cleanedLineupHistory,
    removedCount,
    needsRepair: removedCount > 0,
  };
};

export const getEmptyLineupSnapshotCount = (faction) =>
  buildFactionLineupHistoryRepair(faction).removedCount;
